import { Component } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { environment } from 'src/environments/environment';
import { PAGE_SIZE, MAX_SIZE } from 'src/app/onelog/common/config/common';

@Component({
  selector: 'app-osd-log',
  templateUrl: './osd-log.component.html',
  styleUrls: ['./osd-log.component.css'],
})
export class OsdLogComponent {
  apiURL = environment.sachWebURL;
  selectedproductId: string = '';
  products: any = [];
  selectedUserId: string = '';
  selectStatusTypeDropDownOptions: any = [
    'not equal to',
    'not in',
    'equal to',
    'in',
  ];

  selectedUserIDFilterType: string = '';
  selectedUserIDFilterData: any = [];

  selectedProductID: string = '';
  selectedProdcutIDFilterType: string = '';
  selectedProductIDFilterData: any = [];
  filtersData: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 0;
  searchBtnText: string = 'Search';
  showSearchLoading: boolean = false;
  pageSize: number = PAGE_SIZE;
  maxSize: number = MAX_SIZE;

  constructor(private requestService: RequestService) {}

  ngOnInit() {
    this.getProducts();
  }

  getProducts() {
    this.setSearching();
    this.requestService.getRequest('/get_osd_log').subscribe((data: any) => {
      console.log(data);
      this.products = data.data;
      this.totalProducts = data.total;
      this.perPage = data.per_page;
      this.lastPage = data.last_page;
      this.currentPage = data.current_page;
      this.unsetSearching();
    });
  }

  getFilteredData(url: string, postData: any, urlParams: string) {
    this.setSearching();
    this.requestService
      .postRequest('/get_osd_log', postData, urlParams)
      .subscribe((data: any) => {
        console.log(data);
        this.products = data.data;
        this.products = data.data;
        this.totalProducts = data.total;
        this.perPage = data.per_page;
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;

        this.unsetSearching();
      });
  }

  searchProduct() {
    console.log('Search Product');
    console.log(this.selectedUserIDFilterType);
    this.setStatusFilterData();
    this.getFilteredData('/get_osd_log', this.createPostData(), '');
  }

  updateSelectedType(event: any) {
    console.log(event);

    if (event.name == 'userId') {
      this.selectedUserIDFilterType = event.selectedOption;
    }

    if (event.name == 'productID') {
      this.selectedProdcutIDFilterType = event.selectedOption;
    }
  }

  setStatusFilterData() {
    if (
      this.selectedUserIDFilterType !== null &&
      this.selectedUserIDFilterType !== ''
    ) {
      this.selectedUserIDFilterData['UserId'] = this.selectedUserId;
      this.selectedUserIDFilterData['selectedFilterType'] =
        this.selectedUserIDFilterType;
    }

    if (
      this.selectedProdcutIDFilterType !== null &&
      this.selectedProdcutIDFilterType !== ''
    ) {
      this.selectedProductIDFilterData['ProductId'] = this.selectedProductID;
      this.selectedProductIDFilterData['selectedFilterType'] =
        this.selectedProdcutIDFilterType;
    }

    console.log(
      this.selectedUserIDFilterData,
      this.selectedProductIDFilterData
    );
  }

  createPostData() {
    return {
      selectedUserID: Object.assign({}, this.selectedUserIDFilterData),
      selectedProdID: Object.assign({}, this.selectedProductIDFilterData),
    };
  }

  downloadReport() {
    let urlParams = '?is_download=1';
    this.setStatusFilterData();
    this.requestService.download(
      '/get_osd_log',
      this.createPostData(),
      urlParams,
      'dev-my-title-' + new Date().toLocaleString() + '.csv'
    );
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    console.log(eventData.currentPage);
    let urlParams = '?page=' + eventData.currentPage;
    this.setStatusFilterData();
    this.getFilteredData('/get_osd_log', this.createPostData(), urlParams);
  }

  setSearching() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;
  }

  unsetSearching() {
    this.searchBtnText = 'Search';
    this.showSearchLoading = false;
  }
}
